import qs from 'qs';
import axios from 'axios';
import get from 'lodash/get';
import config from 'config';
import { refreshToken } from 'api/auth';
import { parseJSON } from 'utils/general';

const serverConfig = {
  // ams instance 1
  '01958f47-50b2-7177-88e1-d37f430a9106': {
    baseUrl: config.apiUrl1,
  },
  '01959353-da28-7c8e-82c8-7489644499d9': {
    baseUrl: config.apiUrl2,
  },
};

export const getCentralBaseUrl = () => {
  return config.apiUrl;
  // return get(serverConfig[id], 'baseUrl');
};
const baseUrl = config.apiUrl;

const getFullUrl = (url) => {
  const instanceId = localStorage.getItem('asInstanceId');
  let instanceBaseUrl = config.apiUrl;
  if (instanceId) {
    instanceBaseUrl = serverConfig[instanceId].baseUrl;
  }
  return !(/^(http|https):\/\//.test(url)) ? `${instanceBaseUrl}${url}` : url;
};

// const getFullUrl = (url) => {
//   return !(/^(http|https):\/\//.test(url)) ? `${baseUrl}${url}` : url;
// };

const getOAuthClientCredential = () => ({
  username: config.oauthClientId,
  password: config.oauthClientSecret,
});

export const getStoredAuth = () => {
  if (localStorage.getItem('auth')) {
    return parseJSON(localStorage.getItem('auth'));
  }
  return null;
};

export const setStoredAuth = (auth) => {
  localStorage.setItem('auth', JSON.stringify(auth));
};

const getRequestConfig = (authType, contentType) => {
  const auth = authType === 'bearer' ? getStoredAuth() : null;
  const token = get(auth, 'access_token');
  return {
    ...(authType === 'basic' ? { auth: getOAuthClientCredential() } : {}),
    headers: {
      'Accept': 'application/json',
      'Content-Type': contentType || 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
};

const apiCallWithRefresh = (apiCall, requestConfig, authType) => {
  return apiCall(requestConfig)
    .catch(async (err) => {
      if (authType === 'basic') {
        throw err;
      }
      const storedAuth = getStoredAuth();
      if (
        get(storedAuth, 'access_token')
        && get(err, 'response.status') === 401
      ) {
        try {
          await refreshToken(get(storedAuth, 'refresh_token'));
        } catch {
          throw err;
        }
        try {
          const newRequestConfig = {
            ...requestConfig,
            ...getRequestConfig(authType),
          };
          return apiCall(newRequestConfig);
        } catch (retryErr) {
          if (get(retryErr, 'response.status') === 401) {
            throw err;
          }
          throw retryErr;
        }
      }
      throw err;
    });
};

// Arrays become repeated keys (a=1&a=2), e.g. several $orderby fields.
export const serializeParams = (params) => qs.stringify(params, { arrayFormat: 'repeat' });

const api = {
  get: (url, params, authType) => {
    const fullUrl = getFullUrl(url);
    const requestConfig = {
      ...getRequestConfig(authType),
      paramsSerializer: serializeParams,
      params,
    };
    const apiGet = (rConfig) => axios.get(fullUrl, rConfig);
    return apiCallWithRefresh(apiGet, requestConfig, authType);
  },
  post: (url, body, authType) => {
    const fullUrl = getFullUrl(url);
    const data = JSON.stringify(body);
    const requestConfig = getRequestConfig(authType);
    const apiPost = (rConfig) => axios.post(fullUrl, data, rConfig);
    return apiCallWithRefresh(apiPost, requestConfig, authType);
  },
  put: (url, body, authType) => {
    const fullUrl = getFullUrl(url);
    const data = JSON.stringify(body);
    const requestConfig = getRequestConfig(authType);
    const apiPut = (rConfig) => axios.put(fullUrl, data, rConfig);
    return apiCallWithRefresh(apiPut, requestConfig, authType);
  },
  delete: (url, authType) => {
    const fullUrl = getFullUrl(url);
    const requestConfig = getRequestConfig(authType);
    const apiDelete = (rConfig) => axios.delete(fullUrl, rConfig);
    return apiCallWithRefresh(apiDelete, requestConfig, authType);
  },
  postUrlFormEncoded: (url, body, authType) => {
    const fullUrl = getFullUrl(url);
    const data = qs.stringify(body);
    const requestConfig = getRequestConfig(authType, 'application/x-www-form-urlencoded');
    const apiPost = (rConfig) => axios.post(fullUrl, data, rConfig);
    return apiCallWithRefresh(apiPost, requestConfig, authType);
  },
  postMultipart: (url, body, authType) => {
    const fullUrl = getFullUrl(url);
    const requestConfig = getRequestConfig(authType, 'multipart/form-data');
    const apiPost = (rConfig) => axios.postForm(fullUrl, body, rConfig);
    return apiCallWithRefresh(apiPost, requestConfig, authType);
  },
};

export default api;
